import {
  renderRichText,
  StoryblokComponent,
  storyblokEditable,
} from "@storyblok/react";
import { MegaMediaBannerV2Model } from "./MegaMediaBannerV2Model";

import "./MegaMediaBannerV2.css";
import Utils from "../../core/Utils/Utils";

const MegaMediaBannerV2: React.FC<{ blok: MegaMediaBannerV2Model }> = ({
  blok,
}) => {
  const isVideo = blok.media?.filename?.endsWith(".mp4");
  const bodyHTML = renderRichText(blok.subText) || "";

  return (
    <div {...storyblokEditable(blok)} className="mega-media-banner-v2">
      {isVideo && (
        <video
          autoPlay
          loop
          muted
          playsInline
          src={Utils.getCacheUrl(blok.media?.filename)}
          data-object-fit="cover"
          onError={(e) => Utils.handleVideoError(e, blok.media.filename)}
        ></video>
      )}
      {!isVideo && blok.media?.filename && (
        <img
          src={Utils.getCacheUrl(blok.media.filename)}
          alt=""
          onError={(e) => Utils.handleImageError(e, blok.media.filename)}
        />
      )}

      <div className="container">
        <div
          className="mega-media-banner-block"
          style={{ backgroundColor: blok.blockColor }}
        >
          <div className="title" style={{ color: blok.textColor }}>
            {blok.text}
          </div>
          <div
            className="subtitle"
            style={{ color: blok.subTextColor }}
            dangerouslySetInnerHTML={{ __html: bodyHTML }}
          ></div>
          <div className="action-area">
            {blok.buttons
              ? blok.buttons.map((button) => (
                  <StoryblokComponent
                    blok={button}
                    key={button._uid}
                    className="button"
                  />
                ))
              : null}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MegaMediaBannerV2;
